// extracted by mini-css-extract-plugin
export default {"dashboard":"projects_dashboard__u5zCo","dashboard__full":"projects_dashboard__full__-sUsw","loader":"projects_loader__1YCgZ"};